import { 
  Zap, 
  Search, 
  BarChart3, 
  Globe, 
  MessageSquare, 
  Mail, 
  CheckCircle2,
  LucideIcon
} from "lucide-react";

export interface ServiceItem {
  title: string;
  slug: string;
  description: string;
  icon: LucideIcon;
  content: string;
  features: string[];
}

export const SERVICES: ServiceItem[] = [
  {
    title: "Dotson HUB",
    slug: "dotson-hub",
    description: "Unified command center to capture leads, automate operations, and book appointments.",
    icon: Zap,
    content: "Dotson HUB is a centralized platform that gives local businesses complete command over their customer pipeline and daily operations without multiple software subscriptions.",
    features: ["Unified Lead Capture", "Centralized Conversation Inbox", "Automated Pipeline Progression", "Effortless Calendar Booking", "Consistent Client Follow Up"]
  },
  {
    title: "Search Engine Optimization",
    slug: "seo",
    description: "Drive organic traffic and dominate search results with our data-backed SEO strategies.",
    icon: Search,
    content: "Our SEO services are designed to increase visibility and drive high-quality organic traffic to your website. We focus on technical SEO, on-page optimization, and high-authority link building to ensure long-term success in search engine rankings.",
    features: ["Keyword Research & Strategy", "Technical SEO Audits", "On-Page Optimization", "Link Building", "Local SEO Optimization"]
  },
  {
    title: "Pay-Per-Click Advertising",
    slug: "ppc",
    description: "Maximize ROI with precision-targeted ad campaigns across Google and social platforms.",
    icon: BarChart3,
    content: "Our PPC experts manage your ad spend with precision, targeting the right audience at the right time. We optimize for conversions, ensuring every dollar spent contributes to your bottom line through Google Ads, Bing Ads, and Social Media advertising.",
    features: ["Google Ads Management", "Social Media Advertising", "Remarketing Campaigns", "A/B Testing", "Conversion Rate Optimization"]
  },
  {
    title: "Web Development",
    slug: "web-development",
    description: "High-performance, conversion-optimized websites built for modern business needs.",
    icon: Globe,
    content: "We build fast, secure, and responsive websites that don't just look great but also convert visitors into customers. Our development process focuses on user experience, performance, and scalability.",
    features: ["Custom Web Design", "E-commerce Solutions", "CMS Integration", "Performance Optimization", "Responsive Design"]
  },
  {
    title: "Social Media Marketing",
    slug: "social-media",
    description: "Build brand authority and engage your audience where they spend their time.",
    icon: MessageSquare,
    content: "Engage your audience and build a loyal community around your brand. We handle everything from content creation to community management and paid social strategies.",
    features: ["Platform Strategy", "Content Creation", "Community Management", "Influencer Outreach", "Social Analytics"]
  },
  {
    title: "Email Marketing",
    slug: "email-marketing",
    description: "Nurture leads and drive repeat business with personalized email automation.",
    icon: Mail,
    content: "Turn your email list into a powerful revenue stream. We design and implement automated email sequences that nurture leads and encourage repeat purchases.",
    features: ["Automation Workflows", "Newsletter Design", "List Segmentation", "Campaign Management", "Performance Tracking"]
  },
  {
    title: "Google Business Profile Automations",
    slug: "gbp-automation",
    description: "Automate 5-star review acquisition, customer responses, and active profile optimization to dominate local search.",
    icon: CheckCircle2,
    content: "We actively manage and automate your Google Business Profile to generate consistent 5-star reviews, craft on-brand customer responses, showcase fresh imagery, and build unbeatable local trust so ready-to-buy clients choose you every single time.",
    features: ["Automated 5-Star Review Engine", "Intelligent Response Management", "Continuous Media & Product Updates", "Local Map Pack Rank Escalation", "Amazon-Level Trust & Conversion Dominance"]
  },
];
